import { createRouter, createWebHistory } from 'vue-router'

// Main pages
import MainLayout from '../layouts/MainLayout.vue'
import EmailAssistant from '../pages/EmailAssistant.vue'
import DocumentGenerator from '@/pages/DocumentGenerator.vue'
import LoginPage from '@/pages/LoginPage.vue'
import IamUsers from '@/pages/IamUsers.vue'
import ChangePassword from '@/pages/ChangePassword.vue'
import AdminDashboard from '@/pages/AdminDashboard.vue'

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      { path: '', redirect: '/email' },

      // Protected pages
      {
        path: 'email',
        name: 'email',
        component: EmailAssistant,
        meta: { requiresAuth: true }
      },
      {
        path: 'document',
        name: 'document',
        component: DocumentGenerator,
        meta: { requiresAuth: true }
      },
      {
       path: 'iam/users',
       name: 'iam-users',
       component: IamUsers,
       meta: { requiresAuth: true }
     },
     {
      path: 'change-password',
      name: 'change-password',
      component: ChangePassword,
      meta: { requiresAuth: true }
     },
     {
      path: 'iam/groups',
      name: 'iam-groups',
      component: () => import('@/pages/IamGroups.vue'),
      meta: { requiresAuth: true }
     },

     // Admin Dashboard (child route => no leading slash)
     {
      path: 'admin',
      name: 'admin',
      component: AdminDashboard,
      meta: { requiresAuth: true, requiresAdmin: true }
     }
    ]
  },

  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/pages/ResetPassword.vue')
  },

  {
    path: '/invite/:uid/:token',
    name: 'InviteAccept',
    component: () => import('@/pages/InviteAccept.vue'),
    meta: { requiresAuth: false }
  },

  // Public login page
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('access')
  if (to.meta.requiresAuth && !isLoggedIn) next('/login')
  else next()
})

export default router
